// src/config.js

/**
 * Application Configuration
 * * This file centralizes all environment-dependent variables.
 * By using this file, we avoid hardcoding values like API endpoints
 * across the application, making it easier to manage different environments
 * (e.g., development, staging, production).
 */

// Fetch the API base URL from environment variables.
// It defaults to 'http://localhost:3000' if the .env variable is not set.
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

// You can add other global configurations here in the future.
// For example:
// export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;